import Vue, { CreateElement, VNode } from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

//Styles
import styles from './CreditSection.module.scss';
import { SubscriptionComponentsEmbeddedCreditCardComponent } from '../../../../subscription/components/Shared/EmbeddedCreditCard/EmbeddedCreditCard';
import { SettingsStoreInfoModule } from '../../../../settings/store/store-settings-module';
import { PaymentConfigGatways } from '../../../../api/model/payment-configs.interface';

@Component
export class ZidWalletComponentsAddFundsBankTransferSectionComponent extends Vue {
  @Prop()
  private readonly submitCreditCard!: boolean;

  async created(): Promise<void> {
    if (!SettingsStoreInfoModule.paymentsConfigs) await SettingsStoreInfoModule.getStorePaymentConfig();
  }

  private get walletConfig(): PaymentConfigGatways | null {
    return SettingsStoreInfoModule.paymentsConfigs;
  }
  private get walletConfigCurrency(): string {
    return this.walletConfig ? (this.walletConfig['tap.zid_wallet.sdk.currency'] as string) : '';
  }
  private get walletConfigPK(): string {
    return this.walletConfig ? (this.walletConfig['tap.zid_wallet.sdk.pk'] as string) : '';
  }
  private get walletConfigMerchantId(): number | undefined {
    return this.walletConfig ? (this.walletConfig['tap.zid_wallet.sdk.mid'] as number) : undefined;
  }

  render(h: CreateElement): VNode {
    return (
      <div>
        {this.walletConfig ? (
          <SubscriptionComponentsEmbeddedCreditCardComponent
            class={styles.embeddedcreditcard__cardcontainer}
            onTokenCreated={this.onTokenCreated}
            onDisableSubmit={this.disableSubmit}
            purchaseSource='wallet'
            ref='saveForm'
            currency={this.walletConfigCurrency}
            merchantId={this.walletConfigMerchantId}
            publicKey={this.walletConfigPK}
          />
        ) : (
          ''
        )}
      </div>
    );
  }

  @Watch('submitCreditCard')
  onSumbitChange(): void {
    if (this.submitCreditCard) {
      const saveForm = this.$refs.saveForm as SubscriptionComponentsEmbeddedCreditCardComponent;
      saveForm.createToken();
    }
  }

  private disableSubmit(event: boolean): void {
    this.$emit('disableSubmitEmbeddedCreditCard', event);
  }

  private onTokenCreated(token: any): void {
    this.$emit('submitWithEmbeddedCreditCard', token);
  }
}
